export default function validation(response, messages) {
  if (!response.data || !response.data.error || !response.data.error.validationErrors) {
    return;
  }
  response.data.error.validationErrors.forEach((error) => {
    if (!error.message) return;
    const message = error.message;
    if (message.indexOf('SIGNATURE_REQUEST_WAS_NOT_PASSED') === 0) {
      messages.push({
        message: 'validation.requestWasNotPassed',
      });
    }
    if (message.indexOf('SIGNATURE_TOKEN_EMPTY') === 0) {
      messages.push({
        message: 'signatureElectronique.error.tokenEmpty',
      });
    }
    if (message.indexOf('SIGNATURE_REFERENCE_EXTERNE_EMPTY') === 0) {
      messages.push({
        message: 'signatureElectronique.error.referenceExterneEmpty',
      });
    }
  });
}
